import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from '../../../cluster-assigned-records/gql'
import type { Context } from '../../types'

/**
 * API used by the record-owned cluster assignment workflow
 */
@ngCore.Injectable()
export class Api {
  /**
   * Assigns records to the selected cluster
   */
  public assign({
    clusterId,
    context,
    recordIds: spaceRecordIds,
  }: Api.AssignInput): rxjs.Observable<void | undefined> {
    return gql.mutations.addSpaceRecordsToCluster.executor({
      ...context,
      clusterId,
      spaceRecordIds,
    })
  }

  /**
   * Removes one record from its assigned cluster
   */
  public unassign({
    clusterId,
    context,
    recordId,
  }: Api.UnassignInput): rxjs.Observable<void | undefined> {
    return gql.mutations.removeSpaceRecordFromCluster.executor({
      ...context,
      clusterId,
      spaceRecordId: recordId,
    })
  }
}
export namespace Api {
  export interface AssignInput {
    readonly context: NonNullable<Context>
    readonly clusterId: ents.extra.space.Cluster.Id
    readonly recordIds: readonly ents.extra.space.Record.Id[]
  }
  export interface UnassignInput {
    readonly context: NonNullable<Context>
    readonly clusterId: ents.extra.space.Cluster.Id
    readonly recordId: ents.extra.space.Record.Id
  }
}
